import(/* webpackMode: "eager" */ "C:\\Users\\dhux6\\OneDrive\\Documents\\Dev\\ghostnet-commece\\node_modules\\next\\dist\\client\\link.js")